import { useState, useEffect } from 'react';
import SocketService, { SocketService as ISocketService } from '../services/socket-service';

const useSocket = (enable: boolean = true) => {
  const [connection, setConnection] = useState<ISocketService | undefined>(
    enable ? SocketService.getInstance() : undefined
  );

  useEffect(() => {
    if (enable) {
      setConnection(SocketService.getInstance());
    } else {
      setConnection(undefined);
    }
  }, [enable]);

  return connection;
};

export default useSocket;
